var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',[_c('b-col',{attrs:{"cols":"1"}}),_c('b-col',{attrs:{"cols":"10"}},[_c('b-form-group',{attrs:{"label-cols":"4","label-cols-lg":"2","label-size":"md","label":"Entity Type:","label-for":"input-sm"}},[_c('b-form-select',{attrs:{"options":_vm.entityTypes},on:{"change":_vm.selectEntityType},model:{value:(_vm.selectedEntityType),callback:function ($$v) {_vm.selectedEntityType=$$v},expression:"selectedEntityType"}})],1)],1),_c('b-col',{attrs:{"cols":"1"}})],1),_c('b-row',[_c('b-col',{attrs:{"cols":"1"}}),_c('b-col',{attrs:{"cols":"10"}},[_c('b-form-group',{attrs:{"label-cols":"4","label-cols-lg":"2","label-size":"md","label":"Notification Type:","label-for":"input-sm"}},[_c('b-form-select',{attrs:{"options":_vm.notificationTypes,"disabled":_vm.isAssignedNotificationEnabled},on:{"change":_vm.notificationYearSelected},model:{value:(_vm.selectedNotificationId),callback:function ($$v) {_vm.selectedNotificationId=$$v},expression:"selectedNotificationId"}})],1)],1),_c('b-col',{attrs:{"cols":"1"}})],1),_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('editor',{attrs:{"api-key":"hrb21ypd40shtmcr0kef33uwq67i8gd23ckbp5e2ex5znwt2","init":{
       height: 500,
       menubar: true,
       mergetags_prefix: '*{',
       mergetags_suffix: '}*',
       mergetags_list:
       [
      {
        title: 'Client',
        menu: [
              {
                value: 'client.givenname',
                title: 'Given name'
              },
              {
                value: 'client.familyname',
                title: 'Family name'
              },
              {
                value: 'client.company',
                title: 'Company'
              }
              ]
      },
      {
        title: 'Schedule',
        menu: [
              {
                value: 'submission.date',
                title: 'Submission date'
              },
              {
                value: 'completion.date',
                title: 'Completion date'
              }
              ]
      } ],
       plugins: [
         'advlist autolink lists link image charmap print preview anchor',
         'searchreplace visualblocks code fullscreen',
         'insertdatetime media table paste code help wordcount'
       ],
       toolbar:
         'undo redo | formatselect | bold italic backcolor | \
         alignleft aligncenter alignright alignjustify | \
         bullist numlist outdent indent | removeformat |\
          link image fontcolor | help'
     }},model:{value:(_vm.notificationContents ),callback:function ($$v) {_vm.notificationContents =$$v},expression:"notificationContents "}})],1)],1),_c('b-row',{staticStyle:{"padding-top":"3px"}},[_c('b-col',{staticClass:"text-center",attrs:{"cols":"4"}}),_c('b-col',{staticClass:"text-center",attrs:{"cols":"4"}},[_c('b-button',{attrs:{"id":"saveButton","disabled":_vm.saveButtonEnable,"variant":_vm.saveButtonVariant},on:{"click":_vm.saveChanges}},[_vm._v("\n        Save\n      ")]),_c('b-button',{staticStyle:{"margin":"5px"},attrs:{"id":"testEmailButton","variant":_vm.saveButtonVariant,"disabled":_vm.testEmailButtonEnable},on:{"click":_vm.sendTestEmail}},[_vm._v("\n        Test\n      ")]),_c('b-button',{attrs:{"id":"cancelButton","disabled":_vm.saveButtonEnable,"variant":_vm.saveButtonVariant},on:{"click":_vm.saveChanges}},[_vm._v("\n        Cancel\n      ")])],1),_c('b-col',{staticClass:"text-center",attrs:{"cols":"4"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }